<template>
  <view class="tabs-wrapper">
    <!-- 统一按照二维数组渲染 -->
    <view 
      v-for="(group, groupIndex) in normalizedTabs" 
      :key="groupIndex" 
      class="tabs-bar"
    >
      <view 
        v-for="(item, index) in group" 
        :key="index"
        class="tab-btn"
        :class="{ active: modelValue === item.value }"
        @click="handleClick(item)"
      >
        {{ item.label }}
      </view>
    </view>
  </view>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  // 支持一维数组或二维数组
  tabs: {
    type: Array,
    default: () => []
  },
  // 当前激活的 value
  modelValue: {
    type: [String, Number],
    default: ''
  }
});

const emit = defineEmits(['update:modelValue', 'click']);

// 检测传入的是否为二维数组，如果不是，自动包装成二维数组
const normalizedTabs = computed(() => {
  if (!props.tabs || props.tabs.length === 0) return [];
  
  // 如果第一个元素是数组，说明传入的是二维数组，直接返回
  if (Array.isArray(props.tabs[0])) {
    return props.tabs;
  }
  
  // 否则，说明是一维数组，将其包装成二维数组返回
  return [props.tabs];
});

const handleClick = (item) => {
  emit('click', item);
  emit('update:modelValue', item.value);
};
</script>

<style scoped>
.tabs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px; /* 控制多组 Tab 之间的垂直间距 */
}

.tabs-bar {
  display: flex;
  align-items: center;
  gap: 8px; /* 同一组内按钮的水平间距 */
}

.tab-btn {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  background: var(--glass-bg);
  color: var(--text-secondary);
  border: 1px solid transparent;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.tab-btn.active {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.light-mode .tab-btn {
  background: rgba(255, 255, 255, 0.8);
  color: #555;
  border-color: rgba(0, 0, 0, 0.12);
}

.light-mode .tab-btn.active {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}
</style>